import styled from 'styled-components'
import DatePicker from 'react-datepicker'

export const DatePickerContainer = styled.div`
  & .react-datepicker-wrapper {
    width: 100%;
  }
  
  & .react-datepicker__input-container input {
    width: 100%;
    padding: 10px;
    border-radius: 6px;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  display: block !important;
  &.react-datepicker-wrapper {
    display: block !important;
  }
  &.datePicker  {
    width: ${({ fullWidth }) => fullWidth ? '100%' : 'inherit'};
  }
`

export const StyledMonthPicker = styled(DatePicker)`
  display: block !important;
  &.react-datepicker-wrapper {
    display: block !important;
  }
  &.datePicker  {
    width: ${({ fullWidth }) => fullWidth ? '100%' : 'inherit'};
  }
`
